<p *ngIf="loading" class="tt-ai-chat-tool-calls-dialog__state">Loading tool calls...</p>

<tt-toast *ngIf="errorMessage" ttType="danger" ttTitle="AI chat" ttTranslateTitle="false" [ttMessage]="errorMessage" ttTranslateMessage="false"></tt-toast>

<p *ngIf="!loading && !errorMessage && messageGroups.length === 0" class="tt-ai-chat-tool-calls-dialog__state">No API tool calls were made in this conversation.</p>

<tt-card *ngFor="let group of messageGroups; trackBy: trackMessageGroup" class="tt-ai-chat-tool-calls-dialog__message" ttAccordion>
    <span heading class="tt-ai-chat-tool-calls-dialog__message-heading">
        <span class="tt-ai-chat-tool-calls-dialog__prompt" [innerHTML]="getSanitizedPromptHtml(group.promptHtml)"></span>
        <span class="tt-ai-chat-tool-calls-dialog__call-count">{{ group.toolCalls.length }} tool calls</span>
    </span>

    <ul class="tt-ai-chat-tool-calls__ul">
        <li class="tt-ai-chat-tool-calls__tool-call" *ngFor="let toolCall of group.toolCalls; trackBy: trackToolCall">
            <div class="tt-ai-chat-tool-calls__call-datas">
                <span class="tt-ai-chat-tool-calls__tool-call-data">
                    <span class="tt-ai-chat-tool-calls__tool-call-label" ttTranslateWord="ai_tool_call_keyno"></span>
                    <span class="tt-ai-chat-tool-calls__tool-call-info">{{ toolCall.ai_tool_call_keyno }}</span>
                </span>
                <span class="tt-ai-chat-tool-calls__tool-call-data">
                    <span class="tt-ai-chat-tool-calls__tool-call-label" ttTranslateWord="start_datetime"></span>
                    <span class="tt-ai-chat-tool-calls__tool-call-info">{{ toolCall.start_datetime | formatDate: "datetime" : false }}</span>
                </span>
                <span class="tt-ai-chat-tool-calls__tool-call-data">
                    <span class="tt-ai-chat-tool-calls__tool-call-label" ttTranslateWord="runtime_ms"></span>
                    <span class="tt-ai-chat-tool-calls__tool-call-info">{{ toolCall.runtime_ms }} ms</span>
                </span>
            </div>
            <pre><button
                #copyTooltip="matTooltip"
                type="button"
                class="tt-ai-chat-tool-calls__copy-button"
                [matTooltip]="getCopyTooltip(toolCall.ai_tool_call_keyno)"
                [attr.aria-label]="getCopyTooltip(toolCall.ai_tool_call_keyno)"
                (click)="copyFormattedSql(toolCall.sql_code, toolCall.ai_tool_call_keyno, copyTooltip)"
            ><span class="far fa-copy" aria-hidden="true"></span></button><code class="hljs language-sql" [innerHTML]="getHighlightedSql(toolCall.sql_code)"></code></pre>
        </li>
    </ul>
</tt-card>
